import { makeStyles } from '@mui/styles';
import { COLORS } from '../../../EatClubTheme';

import { drawerWidth } from '../../../constants';

const useStyles = makeStyles(
  (theme) => ({
    container: {
      backgroundColor: '#FAF8F5',
      minHeight: '100vh',
      position: 'relative',
      overflowY: 'auto',
      [theme.breakpoints.up('md')]: {
        width: (props) =>
          props?.route?.forceHideNavigation ? '100%' : `calc(100% - ${drawerWidth}px)`,
        marginLeft: (props) => (props?.route?.allowHideNavigation ? 0 : `${drawerWidth}px`),
        // includePadding allows a route to hide the header but still keep the top padding (e.g. /pos-integration)
        padding: (props) =>
          props?.route?.hideHeader && !props?.route?.includePadding ? '0' : '60px',
        // padding: `0 72px 1px 72px`, // That 1px prevents the scrollbar from breaking
        justifyContent: 'center',
      },
      [theme.breakpoints.down('md')]: {
        minHeight: 'calc(100vh - 80px)',
        padding: `20px`,
      },
    },
    containerInner: {
      [theme.breakpoints.up('md')]: {
        maxWidth: '1424px',
        justifyContent: 'center',
        marginLeft: 'auto',
        marginRight: 'auto',
      },
    },
    appBar: {
      color: '#2E2E2E',
      boxShadow: 'none',
      marginBottom: '24px',
    },
    menuLogo: {
      left: '0',
      margin: '0 auto',
      position: 'absolute',
      right: '0',
      width: '150px',
      color: '#E54439',
    },
    sidebar: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
      backgroundColor: '#F5F2ED',
      height: '100%',
    },
    list: {
      marginTop: '16px',
      fontSize: '22px',
    },
    header: {
      display: 'flex',
      width: '100%',
      [theme.breakpoints.up('md')]: {
        marginLeft: '0',
      },
    },
    mobileHeader: {
      alignItems: 'center',
      background: COLORS.LINEN,
      display: 'flex',
      padding: '20px',
      position: 'sticky',
      zIndex: 99,
      top: 0,
      height: '66px',
      [theme.breakpoints.up('md')]: {
        display: 'none',
      },
    },
    breadcrumbContainer: {
      justifyContent: 'center',
      width: '100%',
    },
    headerToolbar: {
      ...theme?.mixins?.toolbar,
      paddingLeft: '0',
      paddingRight: '0',
      marginBottom: '20px',
      // justifyContent: 'center',
      [theme.breakpoints.down('md')]: {
        justifyContent: 'flex-start',
        // paddingLeft: '40px',
      },
    },
    toolbar: {
      ...theme?.mixins?.toolbar,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-start',
      // padding: theme.spacing(0, 0),
      // padding: '0 40px',
      backgroundColor: '#F5F2ED',
    },
    drawerPaper: {
      width: drawerWidth,
      overflowX: 'hidden',
    },
    title: {
      flexGrow: 1,
      fontSize: '40px',
      fontWeight: '500',
      // paddingBottom: '10px',
      maxWidth: '500px',
      lineHeight: '1.36',
      [theme.breakpoints.down('sm')]: {
        fontSize: '30px',
      },
    },
    titleContainer: {
      display: 'flex',
      justifyContent: 'space-between',
      width: '100%',
      height: '100%',
      gap: '20px',
      flexWrap: 'wrap',
      alignItems: 'flex-end',
    },
    /** Offer performance header: title + tabs row with pickers (aligns title row to center) */
    offerPerformanceTitleContainer: {
      alignItems: 'center',
    },
    offerPerformanceHeaderRow: {
      display: 'flex',
      width: '100%',
      flexWrap: 'wrap',
      alignItems: 'center',
      justifyContent: 'space-between',
      gap: '16px',
    },
    offerPerformanceTitleCluster: {
      display: 'flex',
      flexWrap: 'wrap',
      alignItems: 'center',
      gap: '12px',
      minWidth: 0,
      flex: '0 0 auto',
    },
    offerPerformanceTitleTypography: {
      margin: 0,
      flexGrow: 0,
    },
    offerPerformanceActionsCluster: {
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
      flexWrap: 'wrap',
      marginTop: '10px',
    },
    offerPerformanceTitleWithTabsRow: {
      display: 'flex',
      flexWrap: 'wrap',
      alignItems: 'center',
      gap: '16px 24px',
    },
    headerBackNavigation: {
      display: 'flex',
      gap: '10px',
      alignItems: 'center',
    },
    backNavigationLabel: {
      fontSize: '18px',
    },
    backArrowContainer: {
      width: '19px',
      height: '19px',
      position: 'relative',
    },
    hide: {
      display: 'none',
    },
    logo: {
      height: '35px',
      width: '300px',
      display: 'block',
    },
    navText: {
      '& > span': {
        fontSize: '22px',
      },
    },
    headerDivider: {
      margin: '10px 40px 0px 40px',
      backgroundColor: '#E4E4E4',
      [theme.breakpoints.down('md')]: {
        margin: '10px 20px 0px 20px',
      },
    },
    headerButton: {
      [theme.breakpoints.up('md')]: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-end',
        height: '100%',
      },
    },
    flex: {
      display: 'flex',
      gap: '16px',
      alignItems: 'center',
    },
    newLabel: {
      color: COLORS.WHITE,
      backgroundColor: COLORS.OLIVE_2,
      padding: '4px 16px',
      borderRadius: '6px',
      letterSpacing: 1.5,
    },
  }),
  { name: 'Header' },
);

export default useStyles;
